import { gql } from 'graphql.macro';
import { customerSettingsFragment, orgAddressFragment, orgContactFragment } from './common';

export const clinicFragment = gql`
    fragment clinicFields on Clinic {
        _id
        name
        officialName
        organizationNumber
        gln
        parentClinicId
        contact {
            ...orgContactFields
        }
        invoicing {
            costCenter
            vatNo
            invoiceAddress {
                ...orgAddressFields
            }
            communication {
                email
            }
        }
        isNotPickUpAndDeliveryPlace
        active
        externalInfo {
            externalId1
            externalId2
        }
        created {
            on
        }
        customerSettings {
            ...customerSettingsFields
        }
        isWhiteLabeled
        local
        localLabOwner {
            _id
            name
        }
        ptjCustomerNumber
        localeFormat {
            language
            date
            number
        }
    }
    ${orgAddressFragment}
    ${orgContactFragment}
    ${customerSettingsFragment}
`;
